(ns practitest.frontend.version-updates.subs
  (:require [re-frame.core :as re-frame]))

;; Version update subscriptions

(re-frame/reg-sub
 ::version-update
 (fn [db _]
   (get db :version-update)))

(re-frame/reg-sub
 ::version-update-display-type
 :<- [::version-update]
 (fn [version-update _]
   (:display-type version-update)))
